import { React, useState } from 'react'
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { IoIosArrowUp } from 'react-icons/io'
import { IoIosArrowDown } from 'react-icons/io'
import { MdOutlineKeyboardArrowRight } from 'react-icons/md'

export default function Rewards() {


    return (
        <div className="container pt-lg-5 pt-3">
            <div className="d-flex justify-content-center flex-column ">
                <h1 className="h1 text-center">Rewards</h1>
                <p className="text-center heading-desc col-lg-8 col-11 mx-auto">The funds can be claim by the winning wallet after sending a tweet. If winning wallet did not claim reward after 48H fund are going to be sent in treasury !</p>
            </div>


            <div className="row mx-0 mt-4 justify-content-center">
                <div className="col-lg-4 p-2">
                    <div className="card card-dark px-2 pt-3">
                        <div className="card-body d-flex flex-column">
                            <div className="  d-flex justify-content-center py-4">
                                <img src={process.env.PUBLIC_URL + "/assets/images/x-orange.png"} className="w-25" alt="" />
                            </div>

                            <h6 className=" text-center fw-600">Sunday Reward</h6>
                            <div className="d-flex justify-content-between py-2 mt-4 align-items-center border-bottom">
                                <span className=" text-small text-uppercase"> wallet in pool</span>
                                <span className="  text-uppercase ">50</span>
                            </div>
                            <div className="d-flex justify-content-between py-2 mt-4 align-items-center border-bottom">
                                <span className=" text-small text-uppercase"> Reward worth</span>
                                <span className="  text-uppercase "><span className="text-success">$</span>100</span>
                            </div>
                            <div className="d-flex justify-content-between py-2 mt-2 align-items-center border-bottom">
                                <span className=" text-small text-uppercase"> next reward</span>
                                <div className="d-flex flex-column align-items-end">
                                    <span className="  text-uppercase text-faded"><span className="text-uppercase text-faded ps-2">DAYS</span><span className="text-uppercase text-faded ps-2">H</span><span className="text-uppercase text-faded ps-2">M</span></span>
                                    <span className="  text-uppercase ">02  :  14  :  10</span>
                                </div>
                            </div>
                            <span className=" text-small text-uppercase mt-3"> token holding </span>
                            <div className="d-flex justify-content-between py-2 pt-0 align-items-end border-bottom">
                                <span className=" text-small text-uppercase text-faded"> last 5 days </span>
                                <div className="d-flex flex-column">
                                    <span className="  text-uppercase text-end text-faded">Min</span>
                                    <span className="  text-uppercase ">100/200</span>
                                </div>
                            </div>

                            <span className=" text-small text-uppercase mt-3"> token trading </span>
                            <div className="d-flex justify-content-between py-2  pt-0 align-items-end border-bottom">
                                <span className=" text-small text-uppercase text-faded"> last 4 days </span>
                                <div className="d-flex flex-column">
                                    <span className="  text-uppercase text-end text-faded">Min</span>
                                    <span className="  text-uppercase ">800/1,000</span>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center py-4">
                                <button className=" harvest text-uppercase col me-3">twt</button>
                                <button className="ms-3 g-btn col">Claim</button>
                            </div>

                            <div className="d-flex justify-content-between py-2  align-items-center ">
                                <span className=" text-small text-uppercase"> Reward history</span>
                                <span className="  text-uppercase text-small">value</span>
                            </div>
                            <div className="d-flex justify-content-between py-2  align-items-center border-bottom py-3 ">
                                <div className="d-flex">
                                    <span className="  text-uppercase text-faded"> 11.07.21 </span>
                                    <span className="  text-uppercase text-faded ps-3"> 0x000000000000 </span>
                                </div>
                                <span className="  text-uppercase text-success"> $ </span>
                            </div>
                            <div className="d-flex justify-content-between py-2  align-items-center border-bottom py-3 ">
                                <div className="d-flex">
                                    <span className="  text-uppercase text-faded"> 10.31.21 </span>
                                    <span className="  text-uppercase text-faded ps-3"> 0x000000000000 </span>
                                </div>
                                <span className="  text-uppercase text-success"> $ </span>
                            </div>
                            <div className="d-flex justify-content-between py-2  align-items-center  py-3 ">
                                <div className="d-flex">
                                    <span className="  text-uppercase text-faded"> 10.24.21 </span>
                                    <span className="  text-uppercase text-faded ps-3">0x000000000000 </span>
                                </div>
                                <span className="  text-uppercase text-success"> $ </span>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 p-2">
                    <div className="card card-dark px-2 pt-3">
                        <div className="card-body d-flex flex-column">
                            <div className="  d-flex justify-content-center py-4">
                                <img src={process.env.PUBLIC_URL + "/assets/images/x-gray.png"} className="w-25" alt="" />
                            </div>

                            <h6 className=" text-center fw-600">Monthly Reward</h6>
                            <div className="d-flex justify-content-between py-2 mt-4 align-items-center border-bottom">
                                <span className=" text-small text-uppercase"> wallet in pool</span>
                                <span className="  text-uppercase ">40</span>
                            </div>
                            <div className="d-flex justify-content-between py-2 mt-4 align-items-center border-bottom">
                                <span className=" text-small text-uppercase"> Reward worth</span>
                                <span className="  text-uppercase "><span className="text-success">$</span>800</span>
                            </div>
                            <div className="d-flex justify-content-between py-2 mt-2 align-items-center border-bottom">
                                <span className=" text-small text-uppercase"> next reward</span>
                                <div className="d-flex flex-column align-items-end">
                                    <span className="  text-uppercase text-faded"><span className="text-uppercase text-faded ps-2">DAYS</span><span className="text-uppercase text-faded ps-2">H</span><span className="text-uppercase text-faded ps-2">M</span></span>
                                    <span className="  text-uppercase ">03  :  04  :  55</span>
                                </div>
                            </div>
                            <span className=" text-small text-uppercase mt-3"> token holding </span>
                            <div className="d-flex justify-content-between py-2 pt-0 align-items-end border-bottom">
                                <span className=" text-small text-uppercase text-faded"> last 25 days </span>
                                <div className="d-flex flex-column">
                                    <span className="  text-uppercase text-end text-faded">Min</span>
                                    <span className="  text-uppercase ">100/600</span>
                                </div>
                            </div>

                            <span className=" text-small text-uppercase mt-3"> token trading </span>
                            <div className="d-flex justify-content-between py-2  pt-0 align-items-end border-bottom">
                                <span className=" text-small text-uppercase text-faded"> last 16 days </span>
                                <div className="d-flex flex-column">
                                    <span className="  text-uppercase text-end text-faded">Min</span>
                                    <span className="  text-uppercase ">800/5,000</span>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center py-4">
                                <button className=" harvest text-uppercase col me-3">twt</button>
                                <button className="ms-3 g-btn col">Claim</button>
                            </div>

                            <div className="d-flex justify-content-between py-2  align-items-center ">
                                <span className=" text-small text-uppercase"> Reward history</span>
                                <span className="  text-uppercase text-small">value</span>
                            </div>
                            <div className="d-flex justify-content-between py-2  align-items-center border-bottom py-3 ">
                                <div className="d-flex">
                                    <span className="  text-uppercase text-faded"> 11.01.21 </span>
                                    <span className="  text-uppercase text-faded ps-3"> 0x000000000000 </span>
                                </div>
                                <span className="  text-uppercase text-success"> $ </span>
                            </div>
                            <div className="d-flex justify-content-between py-2  align-items-center border-bottom py-3 ">
                                <div className="d-flex">
                                    <span className="  text-uppercase text-faded"> 10.01.21 </span>
                                    <span className="  text-uppercase text-faded ps-3"> 0x000000000000 </span>
                                </div>
                                <span className="  text-uppercase text-success"> $ </span>
                            </div>
                            <div className="d-flex justify-content-between py-2  align-items-center  py-3 ">
                                <div className="d-flex">
                                    <span className="  text-uppercase text-faded"> 09.01.21 </span>
                                    <span className="  text-uppercase text-faded ps-3">0x000000000000 </span>
                                </div>
                                <span className="  text-uppercase text-success"> $ </span>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 p-2">
                    <div className="card card-dark px-2 pt-3">
                        <div className="card-body d-flex flex-column">
                            <div className="  d-flex justify-content-center py-4">
                                <img src={process.env.PUBLIC_URL + "/assets/images/x-golden.png"} className="w-25" alt="" />
                            </div>

                            <h6 className=" text-center fw-600">New Year Reward</h6>
                            <div className="d-flex justify-content-between py-2 mt-4 align-items-center border-bottom">
                                <span className=" text-small text-uppercase"> wallet in pool</span>
                                <span className="  text-uppercase ">10</span>
                            </div>
                            <div className="d-flex justify-content-between py-2 mt-4 align-items-center border-bottom">
                                <span className=" text-small text-uppercase"> Reward worth</span>
                                <span className="  text-uppercase "><span className="text-success">$</span>10,000</span>
                            </div>
                            <div className="d-flex justify-content-between py-2 mt-2 align-items-center border-bottom">
                                <span className=" text-small text-uppercase"> next reward</span>
                                <div className="d-flex flex-column align-items-end">
                                    <span className="  text-uppercase text-faded"><span className="text-uppercase text-faded ps-2">DAYS</span><span className="text-uppercase text-faded ps-2">H</span><span className="text-uppercase text-faded ps-2">M</span></span>
                                    <span className="  text-uppercase ">63  :  12  :  40</span>
                                </div>
                            </div>
                            <span className=" text-small text-uppercase mt-3"> token holding </span>
                            <div className="d-flex justify-content-between py-2 pt-0 align-items-end border-bottom">
                                <span className=" text-small text-uppercase text-faded"> last 180 days </span>
                                <div className="d-flex flex-column">
                                    <span className="  text-uppercase text-end text-faded">Min</span>
                                    <span className="  text-uppercase ">100/2,000</span>
                                </div>
                            </div>

                            <span className=" text-small text-uppercase mt-3"> token trading </span>
                            <div className="d-flex justify-content-between py-2  pt-0 align-items-end border-bottom">
                                <span className=" text-small text-uppercase text-faded"> last 90 days </span>
                                <div className="d-flex flex-column">
                                    <span className="  text-uppercase text-end text-faded">Min</span>
                                    <span className="  text-uppercase ">800/45,000</span>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center py-4">
                                <button className=" harvest text-uppercase col me-3">twt</button>
                                <button className="ms-3 g-btn col">Claim</button>
                            </div>

                            <div className="d-flex justify-content-between py-2  align-items-center ">
                                <span className=" text-small text-uppercase"> Reward history</span>
                                <span className="  text-uppercase text-small">value</span>
                            </div>
                            <div className="d-flex justify-content-between py-2  align-items-center border-bottom py-3 ">
                                <div className="d-flex">
                                    <span className="  text-uppercase text-faded"> 12.31.21 </span>
                                    <span className="  text-uppercase text-faded ps-3"> 0x000000000000 </span>
                                </div>
                                <span className="  text-uppercase text-success"> $ </span>
                            </div>
                            <div className="d-flex justify-content-between py-2  align-items-center border-bottom py-3 ">
                                <div className="d-flex">
                                    <span className="  text-uppercase text-faded"> 12.31.20 </span>
                                    <span className="  text-uppercase text-faded ps-3"> 0x000000000000 </span>
                                </div>
                                <span className="  text-uppercase text-success"> $ </span>
                            </div>
                            <div className="d-flex justify-content-between py-2  align-items-center  py-3 ">
                                <div className="d-flex">
                                    <span className="  text-uppercase text-faded"> 12.31.19 </span>
                                    <span className="  text-uppercase text-faded ps-3">0x000000000000 </span>
                                </div>
                                <span className="  text-uppercase text-success"> $ </span>
                            </div>

                        </div>
                    </div>
                </div>
           
         

            </div>
        </div>
    )
}
